import React from 'react';
import ReactTooltip from 'react-tooltip';

class TileTooltip extends React.Component {

    shouldComponentUpdate(nextProps) {
        let curProps = this.props;

        if (curProps.tooltipId !== nextProps.tooltipId) {
            return true;
        }

        if (curProps.tooltipClass !== nextProps.tooltipClass) {
            return true;
        }

        if (curProps.tooltipPlace !== nextProps.tooltipPlace) {
            return true;
        }

        return false;
    }

    render() {
        var {
            tooltipId,
            tooltipClass,
            tooltipPlace
        } = this.props;

        return <div>
            <div id={`${tooltipId}`}
                 data-place={tooltipPlace}
                 data-multiline="true"
                 data-effect="solid"
                 data-class={`tutor-dark-tooltip ${tooltipClass}`}
                 data-for={tooltipId}
                 data-tip="123"/>
            <ReactTooltip id={tooltipId}>
                {this.props.children}
            </ReactTooltip>
        </div>;
    }
}

export default TileTooltip;